import { render } from "./supplier_com.vue?vue&type=template&id=c33cc554&scoped=true"
import script from "./supplier_com.vue?vue&type=script&lang=js"
export * from "./supplier_com.vue?vue&type=script&lang=js"

import "./supplier_com.vue?vue&type=style&index=0&id=c33cc554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c33cc554"]])

export default __exports__